import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { userActivityApi } from '../api/userActivityApi';
import type { UserActivity } from './types';

export const userActivityKeys = {
  all: ['user-activity'] as const,
  recent: (sinceIso?: string, untilIso?: string) =>
    [...userActivityKeys.all, 'recent', sinceIso ?? 'all', untilIso ?? 'now'] as const,
};

export function useRecentUserActivity(
  sinceIso?: string,
  untilIso?: string,
  options?: Omit<UseQueryOptions<UserActivity[], Error>, 'queryKey' | 'queryFn'>,
) {
  return useQuery({
    queryKey: userActivityKeys.recent(sinceIso, untilIso),
    queryFn: () => userActivityApi.listRecent(sinceIso, untilIso),
    staleTime: 30 * 1000,
    ...options,
  });
}
